import React from 'react';
import { AppContext } from '../../App';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencyValue } from '../../data/utils/getCurrencyValue';
import { labels } from '../../data/labels';

function FastbetToggle(props) {
    const appContext = React.useContext(AppContext);
    const betslipContext = React.useContext(BetslipContext);

    const conf = getConfiguration();
    const amount = getCurrencyValue(betslipContext.addAndBetAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);

    function toggleFastbet() {
        if (betslipContext.isAddAndBetEnabled()) {
            betslipContext.disableAddAndBet();
        } else {
            appContext.toggleFastbetPopup();
        }
    }

    function handleChangeAmount() {
        appContext.toggleFastbetPopup();
    }

    const isEnabled = betslipContext.isAddAndBetEnabled();
    
    return (
        <>
            <div className="d-flex align-items-center justify-content-start mt-4 mb-4">
                <label className="custom-switch-2 mr-2">
                    <input id="fastBetBtn" type="checkbox" onChange={toggleFastbet} checked={isEnabled}></input>
                    <span className="custom-slider-2 round"></span>
                </label>
                <span>{labels['general.fastbet']}</span>
                {isEnabled &&
                    <div className="d-flex align-items-center justify-content-start mt-4 mb-4 pointer" onClick={handleChangeAmount}>
                        <span className="ml-2 mr-2">{labels['live.fastbet.bet_amount']}</span>
                        <span className="bg-bianco">{amount}</span>
                    </div>
                }
            </div>
        </>
    );
}

export default FastbetToggle;